import type { AddTrialExtendBody } from '../types';

export const AddFreeService = Symbol.for('AddFreeService');

/**
 * Add Trial Service
 * 管理试用权限添加逻辑
 */
export interface AddFreeService {
    /**
     * 添加试用权限
     * @param grantedProductIds - 已授权的产品ID列表
     */
    addFreePkg(grantedProductIds: string[]): Promise<void>;

    /**
     * 根据来源判断权限类型
     * @param from - 来源标识
     * @returns 权限类型 ('AIR' | 'LS' | 'INSIGHTS')
     */
    getEmpowerType(from?: string): string;

    /**
     * 检查当前是否启用自动添加试用
     */
    isAutoAddTrialEnabled(): boolean;
}
